<script setup lang="ts">
/**
 * 전역 토스트 스택 — App.vue 에 한 번만 마운트. action 을 가진 에러 토스트는
 * 메시지 + 클릭 가능한 조치 버튼(RouterLink)을 보여준다. 클릭 시 해당 화면으로
 * 이동하며 토스트를 닫는다.
 */
import { storeToRefs } from 'pinia';
import { useToastStore } from '@/stores/toast';

const store = useToastStore();
const { items } = storeToRefs(store);
</script>

<template>
  <div
    class="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 w-[360px] max-w-[calc(100vw-2rem)]"
    role="status"
    aria-live="polite"
  >
    <TransitionGroup name="toast">
      <div
        v-for="t in items"
        :key="t.id"
        class="rounded-card border border-critical/30 bg-canvas shadow-modal px-4 py-3"
      >
        <div class="flex items-start gap-3">
          <p class="text-sm font-semibold text-critical flex-1">{{ t.message }}</p>
          <button
            type="button"
            class="text-secondary-grey hover:text-charcoal-body leading-none"
            aria-label="Dismiss"
            @click="store.dismiss(t.id)"
          >
            ✕
          </button>
        </div>
        <RouterLink
          v-if="t.action"
          :to="t.action.href"
          class="mt-1.5 inline-flex items-center gap-1 text-[13px] font-semibold text-kag-navy hover:underline"
          @click="store.dismiss(t.id)"
        >
          {{ t.action.label }}
          <span aria-hidden="true">→</span>
        </RouterLink>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
